import { ArrowDropDown } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useGrade } from "../gradingModel/hooks";
import { useIRGrade } from "./hooks";
import {
  getAssessmentById,
  getLessonPlan,
} from "../../store/course/courseBaseApi";
import { toast as toastFn } from "react-toastify";
import { generateUUID } from "../../utils";
import Button from "../../components/Button";

export const CourseAccordian = ({
  item,
  courseList,
  diagnosticT2,
  setDiagnosticT2,
  diagnosticT1,
}) => {
  const { gradeList, gradingModelList } = useGrade();
  const { courseMappingListV2 } = useIRGrade();
  const [gradingModel, setGradingModel] = useState();
  const [assessmentId, setAssessmentId] = useState(null);
  const [assessmentName, setAssessmentName] = useState(null);

  const [levelAssignment, setLevelAssignments] = useState({
    courseId: item?.courseId,
    id: item?.id,
    gradingModel: item?.gradingModel || "",
    nextLevelAssessments: item?.nextLevelAssessments || [],
  });

  const fetchLessonPlan = async (_id) => {
    try {
      let { data } = await getLessonPlan({ id: _id });
      if (data?.lessonPlan) {
        const lessonPlan = data?.lessonPlan;
        const section = lessonPlan.sections[0];
        if (section?.chapters?.length > 0) {
          const chapter = section.chapters[0];
          if (chapter?.assessments?.length > 0) {
            const assessmentId = chapter.assessments[0].id;
            setAssessmentId(assessmentId);
          } else {
            toastFn.error("No assessments found");
          }
        } else {
          toastFn.error("No Chapters found");
        }
      } else {
        toastFn.error("No Lesson plan found");
      }
      // setLessonPlanData(data?.lessonPlan)
    } catch (error) {
      console.error(error);
      toastFn.error("Error retrieving Lesson Plan");
    }
  };

  const fetchAssessment = async (_id) => {
    try {
      let { data } = await getAssessmentById({ id: _id });
      setAssessmentName(data?.name);
    } catch (error) {
      console.error(error);
      toastFn.error("Error retrieving Assessment");
    }
  };

  const fetchNextLevelAssessments = (gradingModelId) => {
    const gradingModel = gradingModelList?.find(
      (grade) => grade?.id === gradingModelId,
    );
    const initialAssessments = gradingModel.details.map((item, index) => ({
      id: generateUUID(),
      gradeName: item.gradeName,
      irLevel: "",
      gradingModel: gradingModel?.id,
      maxPercentage: item.max,
      minPercentage: item.min,
    }));
    return initialAssessments;
  };

  useEffect(() => {
    if (levelAssignment && levelAssignment?.courseId) {
      fetchLessonPlan(levelAssignment?.courseId);
    }
  }, [levelAssignment]);

  useEffect(() => {
    if (assessmentId) {
      fetchAssessment(assessmentId);
    }
  }, [assessmentId]);

  const getCourseName = (courseId) => {
    const course = courseList?.find((course) => course.id === courseId);
    return course?.courseName;
  };

  useEffect(() => {
    if (levelAssignment) {
      const gradingModel = gradingModelList?.find(
        (grade) => grade?.id === levelAssignment?.gradingModel,
      );
      setGradingModel(gradingModel);
    }
  }, [gradingModelList, levelAssignment]);

  const handleChange = (e, id) => {
    const { name, value } = e.target;

    if (name === "gradingModel") {
      setLevelAssignments((prevState) => ({
        ...prevState,
        gradingModel: value,
        nextLevelAssessments: fetchNextLevelAssessments(value),
      }));
    }

    if (name === "irLevel") {
      setLevelAssignments((prevState) => ({
        ...prevState,
        nextLevelAssessments: prevState.nextLevelAssessments.map((item) =>
          item.id === id
            ? {
                ...item,
                irLevel: value,
              }
            : item,
        ),
      }));
    }
  };

  const handleSave = () => {
    const isValid = levelAssignment?.nextLevelAssessments?.every(
      (item) => item.irLevel !== "",
    );

    if (!isValid) {
      toastFn.error("Please complete all required fields before saving.");
      return;
    }

    setDiagnosticT2((prevState) => {
      const updatedDiagnosticT2 = [...prevState];

      const existingIndex = updatedDiagnosticT2.findIndex(
        (entry) => entry.id === levelAssignment.id,
      );

      if (existingIndex !== -1) {
        updatedDiagnosticT2[existingIndex] = { ...levelAssignment };
      } else {
        updatedDiagnosticT2.push({ ...levelAssignment });
      }

      return updatedDiagnosticT2;
    });

    toastFn.success("Level Assignments saved successfully!");
  };

  const getGrade = () => {
    let grade = diagnosticT1?.nextLevelAssessments?.find(
      (level) => level?.id === item?.id,
    );
    const gradeName = grade?.gradeName;
    return gradeName;
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ArrowDropDown />}
        aria-controls="panel2-content"
        id="panel2-header"
      >
        <Typography>
          {getCourseName(item?.courseId)} -
          <span style={{ fontWeight: 700 }}> Grade {getGrade()}</span>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid
          sx={styles.gridContainer}
          container
          spacing={2}
          alignItems="center"
        >
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputLabel style={styles.inputLabel}>Assessment </InputLabel>
            <TextField
              name="assessmentName"
              fullWidth
              value={assessmentName || ""}
              disabled
            />
          </Grid>
        </Grid>
        <Grid
          sx={styles.gridContainer}
          container
          spacing={2}
          alignItems="center"
        >
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputLabel style={styles.inputLabel}>Grading Model</InputLabel>
            <FormControl fullWidth>
              <Select
                name="gradingModel"
                value={levelAssignment?.gradingModel || ""}
                placeholder="Select Grading Model"
                onChange={(e) => handleChange(e)}
                sx={{ height: "47px" }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {gradingModelList?.map((item, id) => {
                  return (
                    <MenuItem key={id} value={item.id}>
                      {item.gradingModelName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        {levelAssignment &&
          levelAssignment?.nextLevelAssessments?.length > 0 &&
          levelAssignment?.nextLevelAssessments?.map((item, index) => {
            const isPassGrade = item.gradeName === gradingModel?.passGrade;
            const maxMark = item?.maxPercentage;
            const minMark = item?.minPercentage;
            return (
              <Grid
                sx={styles.gridContainer}
                container
                spacing={2}
                alignItems="center"
                key={item?.id}
              >
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel style={styles.inputLabel}>
                    {isPassGrade ? "(Pass Grade)" : "Grade"}
                  </InputLabel>
                  <TextField fullWidth value={item?.gradeName} disabled />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel style={styles.inputLabel}>IR Level</InputLabel>
                  <FormControl fullWidth>
                    <Select
                      name={"irLevel"}
                      value={item.irLevel || ""}
                      placeholder={"Select IR Level"}
                      onChange={(e) => handleChange(e, item?.id)}
                      sx={{ height: "47px" }}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {courseMappingListV2?.length > 0 &&
                        courseMappingListV2.map((levelItem, idx) => (
                          <MenuItem
                            key={levelItem?.levelId}
                            value={levelItem.irLevel}
                          >
                            {levelItem.irLevel}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            );
          })}
        {levelAssignment &&
          levelAssignment?.nextLevelAssessments?.length > 0 && (
            <Grid
              sx={styles.gridContainer}
              container
              spacing={2}
              alignItems="center"
            >
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Button
                  sx={{ p: 1, fontSize: "14px" }}
                  variant="contained"
                  onClick={handleSave}
                  color="primary"
                  placeholder={"Save"}
                />
              </Grid>
            </Grid>
          )}
      </AccordionDetails>
    </Accordion>
  );
};

const styles = {
  label: {
    color: "var(--mui-palette-common-black)",
    fontWeight: "bold",
  },
  inputLabel: {
    color: "var(--mui-palette-primary-darkGrey)",
    marginBottom: "5px",
    fontWeight: "600",
    fontSize: "1em",
  },
  gridContainer: {
    mt: 1,
    display: "flex",
  },
  suggestionBox: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    marginTop: "10px",
  },
  suggestionItem: {
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "2px",
    cursor: "pointer",
    boxShadow: "0 4px 8px var(--mui-palette-secondary-boxShadow1)",
    backgroundColor: "var(--mui-palette-gray-lightGrey300)",
  },
  uploadBtn: {
    width: "30px",
    height: "30px",
    boxShadow: "none",
    border: "none",
    backgroundColor: "transparent",
    padding: 0,
    borderRadius: "0",
    minWidth: "30px",
  },
  hiddenInput: {
    display: "none",
  },
  actionBtnItem: {
    marginLeft: "5px",
    marginRight: "5px",
    cursor: "pointer",
    display: "flex",
    gap: "20px",
    alignItems: "center",
  },
  row: {
    padding: "5px 16px",
  },
};
